import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import { required } from "utils/validation.util";
import TextField from "app/components/form/TextField";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import DatePickerField from "app/components/form/DatePickerField";
import { WorkScheduleDefinitionMapper } from "features/planner/planner.mappers";
import { WORK_SCHEDULE_FORM } from "features/planner/employee/employee.constants";
import { getWorkScheduleDefinitionFromState } from "features/planner/employee/employee.selectors";
import SelectWorkScheduleDefinition from "features/planner/employee/schedule/components/SelectWorkScheduleDefinition";

const CreateWorkScheduleForm = ({
  handleSubmit,
  selectedWorkScheduleDefinition,
}) => {
  const dayCount = selectedWorkScheduleDefinition.get("dayCount");

  const workScheduleDefinitionIsFinite = dayCount >= 0;

  return (
    <form id={WORK_SCHEDULE_FORM.ID} onSubmit={handleSubmit}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Field
            name={WORK_SCHEDULE_FORM.DEFINITION}
            component={SelectWorkScheduleDefinitionField}
          />
        </Grid>
        {workScheduleDefinitionIsFinite && (
          <Grid item container>
            <Grid item xs={3}>
              <Field
                required
                type="number"
                label="Rotations"
                validate={[required]}
                component={TextField}
                name={WORK_SCHEDULE_FORM.ROTATIONS}
              />
            </Grid>
            <Grid item xs={6} />
          </Grid>
        )}
        <Grid item xs={6}>
          <Field
            component={DatePickerField}
            name={WORK_SCHEDULE_FORM.START_DATE}
            DatePickerProps={{
              label: "Start Date",
            }}
          />
        </Grid>
        <Grid item xs={6}>
          {workScheduleDefinitionIsFinite ? (
            <Field
              label="End Date"
              component={ReadOnlyField}
              name={WORK_SCHEDULE_FORM.END_DATE}
              formatDate={date => formatDate(date, Format.date)}
            />
          ) : (
            <Field
              component={DatePickerField}
              name={WORK_SCHEDULE_FORM.END_DATE}
              DatePickerProps={{
                label: "End Date",
              }}
            />
          )}
        </Grid>
      </Grid>
    </form>
  );
};

const SelectWorkScheduleDefinitionField = ({ input }) => (
  <SelectWorkScheduleDefinition
    value={input.value}
    onChange={input.onChange}
    TextFieldProps={{
      margin: "normal",
    }}
  />
);

CreateWorkScheduleForm.defaultProps = {
  selectedWorkScheduleDefinition: WorkScheduleDefinitionMapper.initial(),
};

export default compose(
  connect((state, { formValueSelector }) => {
    const selectedWorkScheduleDefinitionId = formValueSelector(
      state,
      WORK_SCHEDULE_FORM.DEFINITION,
    );

    return {
      selectedWorkScheduleDefinition: selectedWorkScheduleDefinitionId
        ? getWorkScheduleDefinitionFromState(
            state,
            selectedWorkScheduleDefinitionId,
          )
        : undefined,
    };
  }),
  React.memo,
)(CreateWorkScheduleForm);
